import DoorLockSettings from 'localization/base/pages/DoorLockSettings';

const doorLockSettings: DoorLockSettings = {
  header: 'Zamykání dveří',
  mainDoors: 'Hlavní dveře'
};

export default doorLockSettings;
